import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-reset-password-dialog",
  templateUrl: "./reset-password-dialog.component.html",
  styleUrls: ["./reset-password-dialog.component.scss"],
})
export class ResetPasswordDialogComponent {
  /** Reset code to open the form with directly on the code step (e.g. read from the reset link) */
  public code?: string;

  constructor(
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { code?: string } | null
  ) {
    this.code = data?.code;
  }

  /**
   * Closes the dialog once the password has been reset, returning to the login dialog underneath.
   */
  public resetPasswordFormSubmit(): void {
    this.dialogRef.close();
  }

  /**
   * Closes the dialog when the user cancels the reset password flow, returning to the login dialog underneath.
   */
  public backClick(): void {
    this.dialogRef.close();
  }
}
